import { ROUTES } from '@/shared/config'
import { ContentWrapper, HeaderContent } from '@/shared/ui'
import { NotificationForm } from '@/widgets/NotificationForm'
import { Breadcrumb, Layout } from 'antd'
import { Link } from 'react-router-dom'

export const NotificationCreatePage = () => {
  return (
    <Layout>
      <HeaderContent
        breadcrumbSlot={
          <Breadcrumb
            items={[
              { title: 'Настройки' },
              {
                title: (
                  <Link to={ROUTES.SETTINGS.NOTIFICATIONS}>
                    Push уведомления
                  </Link>
                ),
              },
              {
                title: 'Создание Push уведомления',
              },
            ]}
          />
        }
        title="Создание Push уведомления"
        description="Раздел позволяет создать шаблон push уведомления"
      />

      <ContentWrapper>
        <NotificationForm />
      </ContentWrapper>
    </Layout>
  )
}
